// extracted by mini-css-extract-plugin
export var arrows = "_8g-6";
export var decrementer = "_8g-a";
export var disabled = "_8g-4";
export var error = "_8g-1";
export var hiddenText = "_8g-b";
export var incrementer = "_8g-9";
export var input = "_8g-8";
export var inputWrapper = "_8g-0";
export var leadingIcon = "_8g-c";
export var readonly = "_8g-3";
export var regular = "_8g-7";
export var small = "_8g-5";
export var warning = "_8g-2";